import { AxiosResponse } from "axios";
import AxiosService from "./Axios"
import BaseApi from "./BaseApi";

const BASE_URL = "/alarm-contact";

class AlarmContactApi extends BaseApi {

    constructor() {
        super(BASE_URL);
    }
}

export default AlarmContactApi;
